import { Button, Box, useTheme, styled } from '@mui/material';
import { useFormikContext } from 'formik';
import { FormField } from '../../../../components/FormField/FormField';
import { Checkbox } from '../../../../components/Checkbox/Checkbox';
import { Typography } from '../../../../components/Typography/Typography';
import { AvailableMonthlyTimesheet } from '../../../../types';
import { MultiSelectPeriod } from './MultiselectPeriod';
import { IExportMultiTSForm } from './ExportMultiTimesheetModal';

interface ExportTimesheetsFormProps {
  availablePeriods: AvailableMonthlyTimesheet[];
  hideDataBySelector?: boolean;
}

export const ExportTimesheetsForm = ({
  availablePeriods,
  hideDataBySelector = false,
}: ExportTimesheetsFormProps) => {
  const { colors } = useTheme();
  const { setFieldValue, values } = useFormikContext<IExportMultiTSForm>();

  const labelStyle = {
    color: colors.text.caption,
  };

  if (!availablePeriods.length) {
    return (
      <Typography
        variant='h5'
        color={colors.textAccent.disabled}
        style={{
          padding: '50px',
          textAlign: 'center',
        }}
      >
        No available timesheets to export for selected Submitter(s).
      </Typography>
    );
  }

  return (
    <Content>
      <FormField label='Period' labelStyle={labelStyle}>
        <MultiSelectPeriod availablePeriods={availablePeriods} />
      </FormField>
      {!hideDataBySelector && (
        <FormField label='Show Data By' labelStyle={labelStyle}>
          <Box display='flex' flex={1}>
            <Button
              onClick={() => {
                setFieldValue('showDataBy', 'month');
                setFieldValue('exportCombinedCSV', true);
              }}
              variant={values.showDataBy === 'month' ? 'contained' : 'outlined'}
              style={{
                flex: 1,
                borderRadius: '4px 0px 0px 4px',
              }}
            >
              By Month
            </Button>
            <Button
              onClick={() => {
                setFieldValue('showDataBy', 'week');
              }}
              variant={values.showDataBy === 'week' ? 'contained' : 'outlined'}
              style={{
                flex: 1,
                borderRadius: 0,
              }}
            >
              By Week
            </Button>
            <Button
              onClick={() => {
                setFieldValue('showDataBy', 'weekday');
              }}
              variant={values.showDataBy === 'weekday' ? 'contained' : 'outlined'}
              style={{
                flex: 1,
                borderRadius: '0px 4px 4px 0px',
              }}
            >
              By Weekday
            </Button>
          </Box>
        </FormField>
      )}
      {!hideDataBySelector && (
        <Box display='flex' alignItems='center' gap='8px'>
          <Checkbox
            checked={values.includeEmptyDeals}
            onChange={(e) => setFieldValue('includeEmptyDeals', e.target.checked)}
          />
          <Typography
            variant='body'
            color={colors.text.caption}
            style={{ cursor: 'pointer' }}
            onClick={() => setFieldValue('includeEmptyDeals', !values.includeEmptyDeals)}
          >
            Include empty timesheets
          </Typography>
        </Box>
      )}
    </Content>
  );
};

const Content = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 1rem;
`;
